/**
 * @deprecated
 *
 * Defined in:
 *   {@link file://./../../../dxos/mesh/signal.proto}
 */
export var SignalState;
(function (SignalState) {
    SignalState[SignalState["CONNECTING"] = 0] = "CONNECTING";
    SignalState[SignalState["RECONNECTING"] = 1] = "RECONNECTING";
    SignalState[SignalState["CONNECTED"] = 2] = "CONNECTED";
    SignalState[SignalState["DISCONNECTED"] = 3] = "DISCONNECTED";
    SignalState[SignalState["ERROR"] = 4] = "ERROR";
    SignalState[SignalState["CLOSED"] = 5] = "CLOSED";
})(SignalState || (SignalState = {}));
//# sourceMappingURL=signal.js.map